import React, { Component } from 'react';
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import './recipes.css';


class Recipes extends Component {
    render() {
        return <div className="recipeWrapper">
        {/* <div className="d-flex flex-column flex-md-row align-items-center p-3 px-md-4 mb-3 bg-white border-bottom shadow-sm">
        <h5 className="my-0 ml-md -auto font-weight-normal"></h5>
        <nav className="my-2 my-md-0 mr-md-3">
          <a className="p-2 text-dark" href="#">Features</a>
          <a className="p-2 text-dark" href="#">Enterprise</a>
          <a className="p-2 text-dark" href="#">Support</a>
          <a className="p-2 text-dark" href="#">Pricing</a>
        </nav>
        <a className="btn btn-outline-primary" href="#">Sign up</a>
      </div> */}
      
      <div className="pricing-header px-3 py-3 pt-md-5 pb-md-4 mx-auto text-center">
        <h1 className="display-4">Recipes</h1>
        <p className="lead">Try some of these tasty recipes.</p>
      </div>
      
      <div className="container">
        <div className="card-deck mb-3 text-center">
          <div className="card mb-4 shadow-sm">
            <div className="card-header">
              <h4 className="my-0 font-weight-normal">Appetizers and Soups</h4>
            </div>
            <div className="card-body">
              <h1 className="card-title pricing-card-title"> <small className="text-muted"> </small></h1>
              <ul className="list-unstyled mt-3 mb-4">
                <li>Before your main course, </li>
                <li>here are some tasty </li>
                <li>treats for you and </li>
                <li>your guests to nibble on.</li>
              </ul>
              <Link to="/recipes/appetizers"><button type="button" className="btn btn-lg btn-block btn-outline-light">Go</button></Link>
            </div>
          </div>
          <div className="card mb-4 shadow-sm">
            <div className="card-header">
              <h4 className="my-0 font-weight-normal">Main Course</h4>
            </div>
            <div className="card-body">
              <h1 className="card-title pricing-card-title"> <small className="text-muted"> </small></h1>
              <ul className="list-unstyled mt-3 mb-4">
                <li>When you are ready </li>
                <li>to sit down and  </li>
                <li>eat, these meals will </li>
                <li>satisfy your hunger.</li>
              </ul>
              <Link to="/recipes/appetizers"><button type="button" className="btn btn-lg btn-block btn-outline-light">Go</button></Link>
            </div>
          </div>
          <div className="card mb-4 shadow-sm">
            <div className="card-header">
              <h4 className="my-0 font-weight-normal">Desserts</h4>
            </div>
            <div className="card-body">
              <h1 className="card-title pricing-card-title"> <small className="text-muted"> </small></h1>
              <ul className="list-unstyled mt-3 mb-4">
                <li>If you and your guests </li>
                <li>still have room </li>
                <li>after dinner, try one </li>
                <li>of these sweet desserts.</li>
              </ul>
              <Link to="/recipes/appetizers"><button type="button" className="btn btn-lg btn-block btn-outline-light">Go</button></Link>
            </div>
          </div>
        </div>
      
        
      </div>
      </div>;
    }
};

export default Recipes;